module.exports = __webpack_public_path__ + "imgs/DabventHeaderText.f2ad9e230e511925221a5a719f912a75.svg";